/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated () {
      console.log('New content is available; please refresh.')
      const $updateContainer = document.createElement('div')
      $updateContainer.innerHTML = `
        <style>
          #appUpdate {
            position: fixed;
            top: 20px;
            left: 0;
            right: 0;
            margin-right: 10%;
            margin-left: 10%;
            background-color: rgba(255,255,255,.95);
            padding: 12px 20px;
            border-radius: 4px;
            border: 1px solid #B32B4F;
            border-top: 5px solid #B32B4F;
            font-weight: 700;
            text-align: center;
            box-shadow: 0 0 5px #ccc;
            z-index: 10;
          }
        </style>
        <div id="appUpdate">
          ⚠️ Ein neues Update ist verfügbar.<br>
          Um Fehler zu vermeiden, <a href="#" onclick="window.location.reload()">laden Sie bitte die Seite neu.</a>
        </div>
      `
      const $body = document.querySelector('body')
      $body?.appendChild($updateContainer)
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
